export default (cart, priceField) => cart
    .reduce(
        (total, cartItem) => total + cartItem.product.variant[priceField] * cartItem.quantity,
        0,
    )
    .toFixed(2);
